import { useFocusModeContext } from '@contexts/FocusModeContext'
import { ReadProgress } from './ReadProgress'

/** Keeps Quran information below the visible navbar, or at the top when it hides. */
const PageAndSurahLine = ({ pageData, page }: { pageData: PageData; page: string }) => {
  const isFocusMode = useFocusModeContext()
  if (isFocusMode) return null

  return (
    <>
      <div
        className="page-and-surah sticky z-30 bg-white/95 dark:bg-gray-800/95 shadow-xs backdrop-blur-xs -mx-3 sm:-mx-4 md:mt-2 mb-2 border-gray-100 dark:border-gray-700 border-b xl:rounded-full font-medium tracking-wide transition-[top,background-color] duration-500 ease-in-out"
        style={{
          top: 'calc(var(--banner-height, 0px) + var(--reader-navbar-height, 52px))',
        }}
      >
        <div className="flex justify-between items-center px-6 py-1.5">
          <div className="relative">
            <span>{pageData.surah.name} Suresi</span>
          </div>
          <span>
            Sayfa {page} | {pageData.juz}. Cüz
          </span>
        </div>
        <ReadProgress />
      </div>
    </>
  )
}

export default PageAndSurahLine

export type PageData = {
  surah: {
    name: string
  }
  juz: string
}
